module.exports = __webpack_public_path__ + "img/interactions.9c7e7796.svg";